/**
 * Стек дій, які можна скасувати клавішею (`Ctrl+Z` / `⌘Z` поза полями; UX-14, UX-15): тост
 * «Скасувати» живе 5 с, а клавіша — ще до кінця вікна `ttlMs` блоку `undo` відповіді (60 с).
 * Модуль першого екрана без залежностей: дію кладе лінивий чанк, бере клавіша (`LifecycleKeys` в
 * оболонці). У стеку до 10 дій лише цієї вкладки, у сховище браузера нічого не пишемо
 * (audit-undo.md, розд. 6); скасована дія забувається.
 */

interface UndoEntry {
  run: () => void;
  expiresAt: number;
}

const LIMIT = 10;

let stack: UndoEntry[] = [];

/** Покласти дію в стек до `Date.now() + ttlMs`; одинадцята витісняє найстарішу. */
export function rememberUndo(run: () => void, ttlMs: number): void {
  stack = [...stack, { run, expiresAt: Date.now() + ttlMs }].slice(-LIMIT);
}

/** Забути дію: її вже скасовано тостом чи вона більше не чинна. */
export function forgetUndo(run: () => void): void {
  stack = stack.filter((entry) => entry.run !== run);
}

/** Скасувати останню живу дію; `false` — скасовувати нічого. */
export function runLastUndo(now = Date.now()): boolean {
  stack = stack.filter((entry) => now <= entry.expiresAt);
  const entry = stack.at(-1);
  if (!entry) return false;
  forgetUndo(entry.run);
  entry.run();
  return true;
}

/** Для тестів: стан модуля між тестами. */
export function resetUndoForTests(): void {
  stack = [];
}
